module.exports = __webpack_public_path__ + "img/Symbol3.486871bb.svg";